"use client";

// ⚠️ 临时诊断错误边界：用于捕获并在屏幕上直接展示真实报错与堆栈，便于客户复现后截图反馈。
// 定位完崩溃原因后可删除本文件。

import { useEffect, useState } from "react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    // 同时打印到控制台，方便有 DevTools 时直接查看
    console.error("[诊断错误边界] 捕获到客户端异常:", error);
  }, [error]);

  const detail = [
    `message: ${error?.message ?? "(无)"}`,
    `name: ${error?.name ?? "(无)"}`,
    `digest: ${error?.digest ?? "(无)"}`,
    "",
    "stack:",
    error?.stack ?? "(无堆栈)",
  ].join("\n");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(detail);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // 忽略复制失败
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#1e1e1e",
        color: "#f5f5f5",
        padding: "24px",
        fontFamily: "Consolas, Menlo, monospace",
        boxSizing: "border-box",
      }}
    >
      <h2 style={{ color: "#ff6b6b", marginBottom: 8, fontSize: 18 }}>
        发生客户端异常（诊断信息）
      </h2>
      <p style={{ color: "#aaa", marginBottom: 16, fontSize: 13 }}>
        请把下面的全部内容截图或复制反馈给开发，用于定位崩溃原因。
      </p>

      <div style={{ display: "flex", gap: 12, marginBottom: 12 }}>
        <button
          onClick={handleCopy}
          style={{
            background: "#3b82f6",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "8px 16px",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          {copied ? "已复制 ✓" : "复制全部错误信息"}
        </button>
        <button
          onClick={() => reset()}
          style={{
            background: "#555",
            color: "#fff",
            border: "none",
            borderRadius: 6,
            padding: "8px 16px",
            cursor: "pointer",
            fontSize: 13,
          }}
        >
          重试
        </button>
      </div>

      <textarea
        readOnly
        value={detail}
        style={{
          width: "100%",
          height: "60vh",
          background: "#111",
          color: "#9be29b",
          border: "1px solid #444",
          borderRadius: 6,
          padding: 12,
          fontSize: 12,
          lineHeight: 1.5,
          whiteSpace: "pre",
          overflow: "auto",
          boxSizing: "border-box",
        }}
      />
    </div>
  );
}
